import type { paths } from 'apis/cloud-enterprise-enrollment-api';
import createFetchClient from 'openapi-fetch';
import createClient from 'openapi-react-query';
import { CONFIG } from 'src/config';
import { addAuthHeader } from './middleware/addAuthHeader';
import { throwBodyOnNonOkResponse } from './middleware/throwBody';

const fetchClient = createFetchClient<paths>({
  baseUrl: CONFIG.CloudEnterpriseApiUrl,
});
fetchClient.use(addAuthHeader, throwBodyOnNonOkResponse);

const cloudEnterpriseEnrollmentErrorApi = createClient(fetchClient);

export { cloudEnterpriseEnrollmentErrorApi };
